export default "__VITE_ASSET__C24kjlXi__"